import DataManager from '@/assets/DataManager.js'
import Dato from '@/assets/Dato.js'
import LiveData from '@/assets/LiveData.js'

const ContentController = new function() {
	this.tag;
	this.createHeadline;
	this.contentContainers = {"Tilgængelighedsinfo": [55, 58, 59, 63, 72], "Gangafstande": [67, 68, 69, 70, 71]};
	this.paymentDescription;
	this.contentOrder;

	DataManager.getData([
			DataManager.contentOrder
		], (response) => {

		this.contentOrder = response[0].data;
	});

	this.generateContent = function(feature, contentType, headline, tagId) {
		//console.log(feature);
		var that = this;
		this.tag = contentType;
		this.createHeadline = headline;
		var p = feature.properties;
		var data = '';

		//Check if content contains paymentoptions. If true, get payment options description data.
		for(var i in feature.properties) {
			if(feature.properties[i].id == 99) {
				if(this.paymentDescription == undefined) {
					var that = this;
					$.ajax({
						type: "GET",
						url: "https://apps.odenserundt.dk/data/parkering/payment_order.php",
						async: false
					}).done(function(data) {
						that.paymentDescription = JSON.parse(data);
						//console.log(that.paymentDescription);
					});
				}
			}
		}
		for(var i = 0; i < this.contentOrder.length; i++) {
			var key = 'prop'+this.contentOrder[i];
			//Check if content is multiple values that has to be put into one shared container.
			var inContainer = false;
			for(var x in this.contentContainers) {
				if(this.contentContainers[x].indexOf(this.contentOrder[i]) != -1) {
					inContainer = true;
					break;
				}
			}

			if(!inContainer) {
				if(this[key] != undefined && p[key]) {
					data += this[key](p);
				}
				//Default fallback
				else if(p[key]) {
					data += this[p[key].type](p[key]);
				}
			}
		}

		if(tagId == 51 || tagId == 56) {
			for(var x in this.contentContainers) {
				var html = '<li class="expandable pointer"><div class="content-container"><h5><strong>'+x+'</strong><span class="float-right expandable-icon pointer"><span class="material-icons">keyboard_arrow_down</span></span></h5><ul class="expandable-container hidden">';
				var hasData = false;
				for(var i in this.contentContainers[x]) {
					var key = 'prop'+this.contentContainers[x][i];
					if(this[key] != undefined && p[key]) {
						//console.log(p[key]);
						html += this[key](p);
						hasData = true;
					}
					else if(p[key]) {
						html += this[p[key].type](p[key]);
						hasData = true;
					}

				}
				html += '</ul></div></li>';

				if(!hasData){
					html = "";
				}

				data += html;
				//console.log($.parseHTML(html));
			}
		}

		return data;
	}

	//Relaterede steder
	this.prop19 = function(obj) {
		var html = '';

		return html;
	}

	//Generel beskrivelse
	this.prop24 = function(obj) {
		var html = '';
		if(obj.prop24.value.length != 0 && obj.prop24.value != '<p><br></p>'  && obj.prop24.value != '<p></p>' && obj.prop24.value != '<br>') {
			html += '<'+this.tag+' id="general-description" class="description-value">'+obj.prop24.value+'</'+this.tag+'>';
		}
		return html;
	}

	//Foto 1
	this.prop25 = function(obj) {
		var html = '';
		if(obj.prop25.value.length != 0) {
			if(this.tag == 'div') {
				html += '<'+this.tag+' class="img-1"><img src="https://apps.odenserundt.dk/media/images/thumbnails/'+obj.prop25.value[0].src+'" /></'+this.tag+'>';
			}
		}
		return html;
	}

	//Status i ruteplanlægger - Deprecated value
	this.prop26 = function(obj) {
		return '';
	}

	//Website
	this.prop38 = function(obj) {
		return '';
	}

	//Email
	this.prop41 = function(obj) {
		return '';
	}

	//Telefon
	this.prop42 = function(obj) {
		return '';
	}

	//Antal pladser
	this.prop43 = function(obj, light) {
		var html = '';
		if(obj.prop43.value.length != 0 || obj.prop43.value != '') {
			/*if(this.createHeadline) {
				html += '<h4 class="count-name">'+obj.prop43.name+'</h4>';
			}*/
			if(light) {
				html += '<'+this.tag+'><span>'+obj.prop43.value+' pladser</span></'+this.tag+'>';
			}
			else {
				html += '<'+this.tag+'><span class="input-headline">Antal</span><span class="float-right">'+obj.prop43.value+' pladser</span></'+this.tag+'>';
			}
		}
		return html;
	}

	//Sædehøjde
	this.prop44 = function(obj, light) {
		var html = '';
		if(obj.prop44.value) {
			if(light) {
				html = '<'+this.tag+'><span class="input-headline">'+obj.prop44.name+' </span><span>'+obj.prop44.value+' cm.</span></'+this.tag+'>';
			}
			else {
				html = '<'+this.tag+'><span class="input-headline">'+obj.prop44.name+'</span><span class="float-right">'+obj.prop44.value+' cm.</span></'+this.tag+'>';
			}
		}
		return html;
	}

	//Bemærk
	this.prop47 = function(obj, light) {
		var html = '';
		if(obj.prop47.value) {
			if(obj.prop47.value != '' && obj.prop47.value != '<br>' && obj.prop47.value != '<p><br></p>') {
				if(light) {
					html = '<'+this.tag+'><span class="input-headline">'+obj.prop47.name+' </span><span>'+obj.prop47.value+'</span></'+this.tag+'>';
				}
				else {
					html += '<'+this.tag+'><h5 class="notice-name"><strong>'+obj.prop47.name+'</strong></h5>';
					html += '<p class="notice-value">'+obj.prop47.value+'</p></'+this.tag+'>';
				}
			}
		}
		return html;
	}

	//Betalingsperiode
	this.prop48 = function(obj) {
		var html = '';
		if(obj.prop48.value.length) {
			/*if(this.createHeadline) {
				html += '<h4 class="payment-period-name">'+obj.prop48.name+'</h4>';
			}*/
			html += '<'+this.tag+'>';
			html += '<h5 class="payment-period-headline"><strong>Betalingsperiode</strong></h5>';
			for(var v in obj.prop48.value){
				if(obj.prop48.value[v].from != '' && obj.prop48.value[v].to != '') {
					html += '<p class="">'+obj.prop48.value[v].headline+'<span class="float-right">'+obj.prop48.value[v].from+' - '+obj.prop48.value[v].to+'</span></p>';
				}
			}
			html += '</'+this.tag+'>';
		}
		return html;
	}

	//Pris for parkering
	this.prop49 = function(obj, light) {
		var html = '';
		if(obj.prop49.value.length != 0) {
			if(obj.prop49.value != 0) {
				var value = (obj.prop49.value.length > 5) ? 'Ingen info om pris' : obj.prop49.value+' kr/time';
				if(light) {
					html += '<'+this.tag+'><span>'+value+'</span></'+this.tag+'>';
				}
				else {
					html += '<'+this.tag+'><span class="input-headline">Pris</span><span class="float-right">'+value+'</span></'+this.tag+'>';
				}
			}
		}
		return html;
	}

	//Tidsbegrænsning
	this.prop50 = function(obj, light) {
		var html = '';
		if(obj.prop50.value.length != 0) {
			if(obj.prop50.value != 0) {
				if(light) {
					html += '<'+this.tag+'><span>'+obj.prop50.value+'</span></'+this.tag+'>';
				}
				else {
					html += '<'+this.tag+'><span class="input-headline">Tidsbegrænsning</span><span class="float-right">'+obj.prop50.value+'</span></'+this.tag+'>';
				}
			}
		}
		return html;
	}

	//Trafikanttype
	this.prop51 = function(obj, light) {
		var html = '';
		if(obj.prop51.value.length != 0) {
			if(light) {
				html += '<'+this.tag+' class="transport-type-value"><span class="input-headline">Gælder for: </span><span>'+obj.prop51.value+'</span></'+this.tag+'>';
			}
			else{
				html += '<'+this.tag+' class="transport-type-value"><span class="input-headline">Gælder for</span><span class="float-right">'+obj.prop51.value+'</span></'+this.tag+'>';
			}
		}
		return html;
	}

	//Parkeringstype
	this.prop52 = function(obj, light) {
		var html = '';
		if(obj.prop52.value.length != 0) {
			if(obj.prop62) {
				if(obj.prop62.value.length != 0) {
					var construction = '';
					if(obj.prop62.value[0].value == false) {
						if(obj.prop62.value[1].value == true) {
							construction += 'i p-hus ';
						}
						else if(obj.prop62.value[2].value == true) {
							construction += 'i p-kælder ';
						}
					}
					else if(obj.prop62.value[0].value == true) {
						if(obj.prop62.value[1].value == true) {
							construction += 'i p-hus og på terræn ';
						}
						else if(obj.prop62.value[2].value == true) {
							construction += 'i p-kælder og på terræn ';
						}
					}
					if(light) {
						html += '<li><span class="input-headline"></span><span class="">'+obj.prop52.value+' '+construction+'</span></li>';
					}
					else {
						html += '<li><span class="input-headline">Parkeringstype</span><span class="float-right">'+obj.prop52.value+' '+construction+'</span></li>';
					}

				}
			}
			else {
				if(light) {
					html += '<li><span class="input-headline"></span><span>'+obj.prop52.value+'</span></li>';
				}
				else {
					html += '<li><span class="input-headline">Parkeringstype</span><span class="float-right">'+obj.prop52.value+'</span></li>';
				}
			}
		}
		return html;
	}

	//Admin navn, tlf, website
	this.prop54 = function(obj, light) {
		var html = '';
		html += '<'+this.tag+'>';
		if(!light) {
			html += '<h5 class="input-headline">Administrator</h5>';
			html += '<p class="admin-name"><span class="">Navn</span><span class="float-right">'+obj.prop54.value+'</span></p>';

			if(obj.prop56) {
				if(obj.prop56.value.length != 0) {
					html += '<p class="phone-value"><span class="">Telefon</span><span class="float-right"><a class="phone-number" href="tel:'+obj.prop56.value+'">'+obj.prop56.value+'</a></span></p>';
				}
			}
			if(obj.prop57) {
				if(obj.prop57.value.length != 0) {
					html += '<p class="website-value"><span class="">Hjemmeside</span><span class="float-right"><a href="'+obj.prop57.value+'" target="_blank">Gå til hjemmeside</a></span></p>';
				}
			}
		}
		else {
			html += '<span>Administrator: '+obj.prop54.value+'</span>'
		}
		html += '</'+this.tag+'>';
		return html;
	}

	//Overflade/Jævnhed/Hældning kombi
	this.prop55 = function(obj) {
		var html = '';

		html += '<'+this.tag+'>';
		html += '<span class="input-headline">Overflade</span><span class="float-right">';

		//Jævnhed
		if(obj.prop58) {
			if(obj.prop58.value.length != 0) {
				html += ' '+obj.prop58.value+' overflade med ';
			}
		}

		//Overflade
		if(obj.prop55) {
			if(obj.prop55.value.length != 0) {
				html += obj.prop55.value.toLowerCase()+'. ';
			}
		}

		//Hældning
		if(obj.prop59) {
			if(obj.prop59.value.length != 0 && obj.prop59.value != 'Ingen info') {
				html += obj.prop59.value+' hældning';
			}
		}

		html += '</span></'+this.tag+'>';

		return html;
	}

	//Admin telefon
	this.prop56 = function(obj) {
		var html = '';
		/*if(obj.prop56.value.length != 0) {
			if(this.createHeadline) {
				html += '<h4 class="phone-name">'+obj.prop56.name+'</h4>';
			}
			html += '<'+this.tag+' class="phone-value"><a class="phone-number" href="tel:'+obj.prop56.value+'">'+obj.prop56.value+'</a></'+this.tag+'>';
		}*/
		return html;
	}

	//Admin website
	this.prop57 = function(obj) {
		var html = '';
		/*if(obj.prop57.value.length != 0) {
			if(this.createHeadline) {
				html += '<h4 class="website-name">'+obj.prop57.name+'</h4>';
			}
			html += '<'+this.tag+' class="website-value"><a href="'+obj.prop57.value+'" target="_blank">'+obj.prop57.value+'</a></'+this.tag+'>';
			//html += '<'+this.tag+' class="website-value">Hjemmeside: <a href="#" onclick="window.open('+obj.prop38.value+', "_system");" class="blue-text">Link</a></'+this.tag+'>';
			//html += '<'+this.tag+' class="website-value"><span onclick="window.open(\''+obj.prop57.value+'\', \'_system\');" class="blue-text">'+obj.prop57.value+'</span></'+this.tag+'>';
		}*/
		return html;
	}

	//Jævnhed
	this.prop58 = function(obj) {
		return '';
	}

	//Hældning
	this.prop59 = function(obj) {
		return '';
	}

	//Længde
	this.prop60 = function(obj) {
		var html = '';
		if(obj.prop60.value) {
			/*var roundedValue = Math.round(obj.prop60.value * 100) / 100;
			if(this.createHeadline) {
				html += '<h4 class="length-name">'+obj.prop60.name+'</h4>';
			}*/
			html += '<'+this.tag+'><span class="input-headline">Længde</span><span class="float-right">'+obj.prop60.value.substring(0, 4)+' meter</span></'+this.tag+'>';
		}
		return html;
	}

	//Bredde
	this.prop61 = function(obj) {
		var html = '';
		if(obj.prop61.value) {
			//var roundedValue = Math.round(obj.prop61.value * 100) / 100;
			/*if(this.createHeadline) {
				html += '<h4 class="width-name">'+obj.prop61.name+'</h4>';
			}*/
			html += '<'+this.tag+'><span class="input-headline">Bredde</span><span class="float-right">'+obj.prop61.value.substring(0, 4)+' meter</span></'+this.tag+'>';
		}
		return html;
	}

	//Parkeringstype / Konstruktion
	this.prop62 = function(obj) {
		var html = '';
		/*if(obj.prop62.value[0].value == false) {
			if(obj.prop62.value[1].value == true) {
				html += 'P-hus ';
			}
			else if(obj.prop62.value[2].value == true) {
				html += 'P-kælder ';
			}
		}
		else if(obj.prop62.value[0].value == true) {
			if(obj.prop62.value[1].value == true) {
				html += 'P-hus og på terræn ';
			}
			else if(obj.prop62.value[2].value == true) {
				html += 'P-kælder og på terræn ';
			}
		}*/
		return html;
	}

	//Adgang til betalingsautomat
	this.prop63 = function(obj) {
		console.log(obj);
		var html = '';
		if(obj.prop63.value.length != 0) {
			html += '<'+this.tag+'>';
			html += '<h5 class="input-headline">'+obj.prop63.name+'</h5>';
			//html += '<'+this.tag+' class="payment-options-name"><p>'+obj.prop63.name+'</p><span>';
			var text = [];
			for(var v in obj.prop63.value) {
				if(obj.prop63.value[v].value == true) {
					text.push(' '+obj.prop63.value[v].name);
				}
			}
			html += text.join('.');
			html += '.</span></'+this.tag+'>';
		}
		return html;
	}

	//Plads til lift
	this.prop64 = function(obj){
		var html = '';
		if(obj.prop64.value.length != 0) {
			html += '<'+this.tag+'>';
			html += '<h5 class="input-headline">'+obj.prop64.name+'</h5>';
			for(var v in obj.prop64.value){
				var bool = 'Ja';
				if(obj.prop64.value[v].value == false) {
					bool = 'Nej';
				}
				html += '<p>'+obj.prop64.value[v].name+' <span class="float-right">'+bool+'</span></p>';
			}

			html += '</'+this.tag+'>';
		}
		return html;
	};

	//Frihøjde
	this.prop65 = function(obj) {
		var html = '';
		if(obj.prop65.value) {
			html += '<'+this.tag+'><span class="input-headline">Frihøjde</span><span class="float-right">'+obj.prop65.value.substring(0, 4)+' meter</span></'+this.tag+'>';
		}
		return html;
	}

	//Etage
	this.prop66 = function(obj) {
		var html = '';

		if(obj.prop66.value != 0) {
			html += '<'+this.tag+'><span class="input-headline">Etage</span><span class="float-right">'+obj.prop66.value+'. etage</span></'+this.tag+'>';
		}

		return html;
	}

	//Gangafstand til Vestergade
	this.prop67 = function(obj) {
		var html = '';
		if(obj.prop67.value) {
			var value = obj.prop67.value.split('.');
			html += '<'+this.tag+'><span class="input-headline">'+obj.prop67.name+'</span><span class="float-right">'+value[0]+' meter</span></'+this.tag+'>';
		}
		return html;
	}

	//Gangafstand til Kongensgade
	this.prop68 = function(obj) {
		var html = '';
		if(obj.prop68.value) {
			var value = obj.prop68.value.split('.');
			html += '<'+this.tag+'><span class="input-headline">'+obj.prop68.name+'</span><span class="float-right">'+value[0]+' meter</span></'+this.tag+'>';
		}
		return html;
	}

	//Gangafstand til Flakhaven
	this.prop69 = function(obj) {
		var html = '';
		if(obj.prop69.value) {
			var value = obj.prop69.value.split('.');
			html += '<'+this.tag+'><span class="input-headline">'+obj.prop69.name+'</span><span class="float-right">'+value[0]+' meter</span></'+this.tag+'>';
		}
		return html;
	}

	//Gangafstand til Brandts
	this.prop70 = function(obj) {
		var html = '';
		if(obj.prop70.value) {
			var value = obj.prop70.value.split('.');
			html += '<'+this.tag+'><span class="input-headline">'+obj.prop70.name+'</span><span class="float-right">'+value[0]+' meter</span></'+this.tag+'>';
		}
		return html;
	}

	//Gangafstand til Koncerthuset
	this.prop71 = function(obj) {
		var html = '';
		if(obj.prop71.value) {
			var value = obj.prop71.value.split('.');
			html += '<'+this.tag+'><span class="input-headline">'+obj.prop71.name+'</span><span class="float-right">'+value[0]+' meter</span></'+this.tag+'>';
		}
		return html;
	}

	//Højde på betalingsautomat
	this.prop72 = function(obj) {
		var html = '';
		if(obj.prop72.value) {
			html += '<'+this.tag+'><span class="input-headline">Højde på betalingsautomat</span><span class="float-right">'+obj.prop72.value.substring(0, 4)+' meter</span></'+this.tag+'>';
		}
		return html;
	}

	//Periode for tidsbegrænsing
	this.prop73 = function(obj) {
		var html = '';
		if(obj.prop73.value.length) {
			html += '<'+this.tag+'>';
			html += '<h5 class="input-headline">'+obj.prop73.name+'</h5>';
			for(var v in obj.prop73.value){
				if(obj.prop73.value[v].from != '' && obj.prop73.value[v].to != '') {
					html += '<p>'+obj.prop73.value[v].headline+'<span class="float-right">'+obj.prop73.value[v].from+' - '+obj.prop73.value[v].to+'</span></p>';
				}
			}
			html += '</'+this.tag+'>';
		}
		return html;
	}

	//Pris i kr
	this.prop77 = function(obj, light) {
		var html = '';
		if(obj.prop77.value > 0) {
			if(light) {
				html = '<'+this.tag+'><span>'+obj.prop77.value+' kr.</span></'+this.tag+'>';
			}
			else {
				html = '<'+this.tag+'><span class="input-headline">'+obj.prop77.name+'</span><span class="float-right">'+obj.prop77.value+' kr.</span></'+this.tag+'>';
			}
		}
		else {
			if(light) {
				html = '<'+this.tag+'><span>Gratis</span></'+this.tag+'>';
			}
			else {
				html = '<'+this.tag+'><span class="input-headline">'+obj.prop77.name+'</span><span class="float-right">Gratis</span></'+this.tag+'>';
			}
		}
		return html;
	}

	//Livedata for parkeringspladser
	this.prop78 = function(obj, light) {
		var html = '';
		var data = LiveData.liveData[obj.prop78.value].freeCount;
		if(obj.prop78.value) {
			var date = new Date();
			var hours = date.getHours();
			var min = date.getMinutes();
			if(min < 10) {
				min = '0'+min;
			}
			if(light) {
				html = '<'+this.tag+'><span>'+data+' ledige (kl. '+hours+':'+min+')</span></'+this.tag+'>';
			}
			else {
				html = '<'+this.tag+'><span class="input-headline">'+obj.prop78.name+'</span><span id="place-live-data" class="float-right">'+data+' (opdateret kl. '+hours+':'+min+')</span></'+this.tag+'>';
			}
			//html = '<'+this.tag+'>'+obj.prop78.value+'</'+this.tag+'>';
		}
		return html;
	}

	//Route string color - ignore
	this.prop85 = function(obj) {
		var html = '';

		return html;
	}

	//Route network - Ignore
	this.prop86 = function(obj) {
		var html = '';

		return html;
	}

	//Oplysninger om motionsplads
	this.prop82 = function(obj) {
		var html = '';
		if(obj.prop82.value) {

		}
		return html;
	}

	//Link til Rejseplanen.dk
	this.prop87 = function(obj, light) {
		var html = '';
		if(obj.prop87.value) {
			if(light) {
				html = '';
			}
			else {
				html = '<'+this.tag+'><span><a href="'+obj.prop87.value+'" target="_blank">Link til Rejseplanen</a></span></'+this.tag+'>';
			}
		}
		return html;
	}

	//Lukning - Midlertidigt eller permanent
	this.prop88 = function(obj) {
		var html = '';
		if(obj.prop88.value == 'Permanent') {
			html = '<h4>Permanent lukket</h4>';
		} else if(obj.prop88.value == 'Midlertidigt') {
			html = '<h4>Midlertidigt lukket</h4>';
		} else {
			html = '';
		}
		return html;
	}

	//Dato forvarsling
	this.prop89 = function(obj) {
		return '';
	}
	//Dato periode
	this.prop90 = function(obj) {
		return '';
	}

	//Toilet type
	this.prop93 = function(obj, light) {
		var html = '';
		var tempArray = [];

		for(var v in obj.prop93.value) {
			if(obj.prop93.value[v].value == true) {
				tempArray.push(obj.prop93.value[v].name);
			} else {

			}
		}

		if(light) {
			html = tempArray.join(' | ');
		}
		else {
			html += '<'+this.tag+'><span class="input-headline">'+obj.prop93.name+'</span><span class="float-right">'+tempArray.join('  |  ')+'</span></'+this.tag+'>';
		}

		return html;
	}

	//Betalingsmuligheder
	this.prop99 = function(obj) {
		var html = '';
		if(obj.prop99.value.length != 0) {
			html += '<'+this.tag+' class="payment-options-name expandable"><h5 class="input-headline pointer">'+obj.prop99.name+'<span class="float-right expandable-icon pointer"><span class="material-icons">keyboard_arrow_down</span></span></h5><ul class="expandable-container hidden"><div class="clearfix"></div>';
			for(var v in obj.prop99.value){
				if(obj.prop99.value[v].pay == true) {
					var descriptionButton = '';
					var description = '';
					for(var k in this.paymentDescription) {
						if(obj.prop99.value[v].id == this.paymentDescription[k].id) {
							descriptionButton = '<span class="small pointer payment-description-btn blue-text"> - Vis mere info</span>';
							description = '<div class="hidden small payment-description">'+this.paymentDescription[k].description+'</div>';
						}
					}
					html += '<li class="payment-row"><span class="small">'+obj.prop99.value[v].name+'</span>'+descriptionButton+'<span class="material-icons green-text float-right">check</span>'+description+'</li>';
				}
			}
			html += '</ul></'+this.tag+'>';
		}
		return html;
	}
	//Følg på Facebook
	this.prop104 = function(obj) {
		return '';
	}

	//Turlængde
	this.prop105 = function(obj, light) {
		return '';
	};

	//Køretøjstype
	this.prop106 = function(obj, light) {
		var html = '';

		if(obj.prop106.value) {
			if(light) {
				html += '<'+this.tag+'><span class=""> '+obj.prop106.value+'</span></'+this.tag+'>';
			}
			else {
				html += '<'+this.tag+'><span class="input-headline">'+obj.prop106.name+'</span><span class="float-right"> '+obj.prop106.value+'</span></'+this.tag+'>';
			}
		}
		return html;
	}

	//Midlertidigt foto
	this.prop108 = function(obj, light) {
		return '';
	}

	//Type af cykelparkering
	this.prop115 = function(obj, light) {
		var html = '';

		if(obj.prop115.value.length != 0) {
			var construction = '';
			for(var i = 0; i < obj.prop115.value.length; i++) {
				if(obj.prop115.value[i].value == true) {
					construction += ' '+obj.prop115.value[i].name + ",";
				}
			}

			// remove last comma
			construction = construction.replace(/,(?=[^,]*$)/, '');

			if(light) {
				html += '<'+this.tag+'><span>'+construction+'</span></'+this.tag+'>';
			}
			else {
				html += '<'+this.tag+'><span class="input-headline">Parkeringstype</span><span class="float-right">'+construction+'</span></'+this.tag+'>';
			}
		}
		return html;
	}

	//Midlertidigt foto - Periode
	this.prop117 = function(obj, light) {
		return '';
	}

	//Design - Bruges til siddepladser tag.
	this.prop118 = function(obj, light){
		//console.log(obj);
		var html = '';
		if(obj.prop118.value.length != 0 && !light) {
			html = '<li class="expandable pointer"><ul class="content-container"><h5 class="input-headline">'+obj.prop118.name+'</h5><div class="expandable-container">';
			for(var v in obj.prop118.value) {
				if(obj.prop118.value[v].value == true) {
					html += '<li><span>'+obj.prop118.value[v].name+'</span></li>';
				} else {

				}
			}
			html += '</div></ul></li>';
		}
		return html;
	};

	//Adgang Via - Bruges til siddepladser tag.
	this.prop119 = function(obj, light){
		//console.log(obj);
		var html = '';
		if(obj.prop119.value.length != 0 && !light) {
			html = '<li class="expandable pointer"><ul class="content-container"><h5 class="input-headline">'+obj.prop119.name+'</h5><div class="expandable-container">';
			for(var v in obj.prop119.value) {
				if(obj.prop119.value[v].value == true) {
					html += '<li><span>'+obj.prop119.value[v].name+'</span></li>';
				} else {

				}
			}
			html += '</div></ul></li>';
		}
		return html;
	};

	//Bruger ønske - Brugernavn
	this.prop121 = function(obj, light) {
		var html = '';
		if(obj.prop121.value) {
			if(!light) {
				html += '<'+this.tag+' id="user-wish-username-li"><span class="input-headline">'+obj.prop121.name+'</span><span class="float-right"> '+obj.prop121.value+'</span></'+this.tag+'>';
			}
		}
		return html;
	}

	//Kommuneplan - Brugernavn
	this.prop136 = function(obj, light) {
		var html = '';
		if(obj.prop136.value) {
			if(!light) {
				html += '<'+this.tag+' id="user-wish-username-li"><span class="input-headline">'+obj.prop136.name+'</span><span class="float-right"> '+obj.prop136.value+'</span></'+this.tag+'>';
			}
		}
		return html;
	}

	this.prop139 = function(obj, light) {
		return '';
	}

	//Kommentarer til brugerønsker
	this.prop122 = function(obj, light) {
		var html = '';
		if(obj.prop122.value) {
			if(!light) {
				html += '<'+this.tag+' class="textarea-value"><span class="input-headline">'+obj.prop122.name+'</span><br>'+obj.prop122.value+'</'+this.tag+'>';
			}
		}
		return html;
	}

	//Kommentarer til brugerønsker fra Odense Kommune
	this.prop123 = function(obj, light) {
		var html = '';
		if(obj.prop123.value) {
			if(!light) {
				html += '<'+this.tag+' class="textarea-value"><span class="input-headline">'+obj.prop123.name+'</span><br>'+obj.prop123.value+'</'+this.tag+'>';
			}
		}
		return html;
	}

	this.prop128 = function(obj, light) {
		var html = '';
		if(obj.prop117) {
			if(obj.prop117.value != null && obj.prop117.value != undefined && obj.prop117.value != 0) {
				var from = new Date(obj.prop117.value.from);
				var to = new Date(obj.prop117.value.to);
				if(from.getTime() < Dato.today.getTime() && Dato.today.getTime() < to.getTime()) {
					if(obj.prop128.value) {
						if(!light) {
							html += '<'+this.tag+' class="textarea-value"><span class="input-headline">'+obj.prop128.name+'</span><br>'+obj.prop128.value+'</'+this.tag+'>';
						}
					}
				}
			}
		}
		return html;
	};

	//Default fallbacks
	this.textarea = function(obj){
		var html = '';
		//if(obj.value.length != 0) {
		if(obj.value) {
			//html += ';
			html += '<'+this.tag+' class="textarea-value"><span class="input-headline">'+obj.name+'</span><br>'+obj.value+'</'+this.tag+'>';
		}
		return html;
	};

	this.input = function(obj){
		var html = '';
		if(obj.value.length != 0) {
			if(obj.value.indexOf('http') == 0) {
				//html += '<'+this.tag+' class="default-link"><a href="'+obj.value+'" target="_blank">'+obj.name+'</a></'+this.tag+'>';
				html += '<'+this.tag+'><span class="input-headline">'+obj.name+'</span><span class="float-right"><a href="'+obj.value+'" target="_blank">Link</a></span></'+this.tag+'>';
			}
			else {
				/*if(this.createHeadline) {
					html += '<h4 class="input-name">'+obj.name+'</h4>';
				}
				html += '<'+this.tag+' class="input-value">'+obj.value+'</'+this.tag+'>';		*/
				html += '<'+this.tag+'><span class="input-headline">'+obj.name+'</span><span class="float-right">'+obj.value+'</span></'+this.tag+'>';
			}
		}
		return html;
	};

	this.livedata = function(obj){
		return '';
	};

	this.select = function(obj, light) {
		var html = '';
		if(obj.value.length != 0) {
			/*if(this.createHeadline) {
				html += '<h4 class="select-name">'+obj.name+'</h4>';
			}		*/
			if(light) {
				html += '<'+this.tag+' class="select-value"><span>'+obj.value+'</span></'+this.tag+'>';
			}
			else {
				html += '<'+this.tag+' class="select-value"><span class="input-headline">'+obj.name+'</span><span class="float-right">'+obj.value+'</span></'+this.tag+'>';
			}
		}
		return html;
	};

	this.checkbox = function(obj) {
		var html = '';
		if(obj.value.length != 0) {
			html = '<li class="expandable pointer"><ul class="content-container"><h5 class="input-headline">'+obj.name+'<span class="float-right expandable-icon pointer"><span class="material-icons">keyboard_arrow_down</span></span></h5><div class="expandable-container hidden">';
			for(var v in obj.value) {
				if(obj.value[v].value == true) {
					html += '<li><span>'+obj.value[v].name+'</span><span class="float-right"><span class="material-icons green-text ">check</span></span></li>';
				} else {

				}
			}
			html += '</div></ul></li>';
		}
		return html;
	};

	this.periodslider = function(obj) {
		var html = '';
		if(obj.value.length != 0) {
			if(this.createHeadline) {
				html += '<p class="periodslider-name">'+obj.name+'</p>';
			}
			html += '<'+this.tag+' class="periodslider-value"><h4>'+obj.value.headline+'</h4><p>'+obj.value.from+' - '+obj.value.to+'</p></'+this.tag+'>';
		}
		return html;
	};

	this.slider = function(obj) {
		var html = '';
		if(obj.value.length != 0) {
			html += '<'+this.tag+'><span class="input-headline">'+obj.name+'</span><span class="float-right">'+obj.value+'</span></'+this.tag+'>';
		}
		return html;
	};

	this.multislider = function(obj, light) {
		var html = '';
		if(obj.value.length != 0) {
			if(light) {
				html += '<span class="select-value">'+obj.name+' ';
				for(var v in obj.value){
					if(obj.value[v].from != '' && obj.value[v].to != '') {
						html += obj.value[v].headline+'<span>'+obj.value[v].from+' - '+obj.value[v].to+'</span>';
					}
				}
				html += '</span>';
			}
			else {
				html += '<'+this.tag+'>';
				html += '<h5 class="input-headline">'+obj.name+'</h5>';
				for(var v in obj.value){
					if(obj.value[v].from != '' && obj.value[v].to != '') {
						html += '<p class="">'+obj.value[v].headline+'<span class="float-right">'+obj.value[v].from+' - '+obj.value[v].to+'</span></p>';
					}
				}
				html += '</'+this.tag+'>';
			}
		}
		return html;
	};

	this.payment = function(obj) {
		var html = '';
		if(obj.value.length != 0) {
			if(this.createHeadline) {
				html += '<h4 class="payment-name">'+obj.name+'</h4>';
			}
			html += '<'+this.tag+'><table class="payment-value">';

			for(var v in obj.value){
				html += '<tr><td>'+obj.value[v].name+': </td><td>'+obj.value[v].pay+'</td><td>'+obj.value[v].pay_before+'</td><td>'+obj.value[v].pay_after+'</td></tr>';
			}

			html += '</table></'+this.tag+'>';
		}
		return html;
	};

	this.date = function(obj) {
		var html = '';
		if(obj.value.length != 0) {
			if(this.createHeadline) {
				html += '<h4 class="date-name">'+obj.name+'</h4>';
			}
			html += '<'+this.tag+' class="date-value"><p>'+obj.value.from+' - '+obj.value.to+'</p></'+this.tag+'>';
		}
		return html;
	};

	this.media = function(obj) {
		return '';
	};

	//Light content
	this.generateLightContent = function(feature, contentType) {
		var p = feature.properties;
		var data = '';
		this.tag = contentType;
		//console.log(feature);
		if(p.prop52) {
			//console.log(feature);
			if(p.prop106) {
				data += '<span>'+p.prop106.value+'</span> | ';
			}
			data += '<span>'+p.prop52.value+'</span> | ';
			if(p.prop52.option_id == 62 || p.prop52.option_id == 63) {
				if(p.prop50 && p.prop43) {
					data += '<span>'+p.prop50.value+' | '+p.prop43.value+' pladser i alt</span> | ';
				}
				else if(p.prop50 && p.prop107) {
					data += '<span>'+p.prop50.value+' | '+p.prop107.value+' pladser i alt</span> | ';
				}
				else if(p.prop50) {
					data += '<span>'+p.prop50.value+'</span> | ';
				}
			}
			else {
				data += '<span>'+p.prop49.value+' kr/time</span> | ';
				if(p.prop78) {
					var liveData = LiveData.liveData[feature.properties.prop78.value];
					liveData = liveData || {freeCount: ""};
					var date = new Date();
					var hours = date.getHours();
					var min = date.getMinutes();
					if(min < 10) {
						min = '0'+min;
					}

					data += '<span class="live-data" data-place-id="'+feature.properties.prop78.value+'">'+liveData.freeCount+' ledige (kl. '+hours+':'+min+')</span> | ';
				}
				else {
					if(p.prop43 && p.prop43.value != '') {
						data += '<span>'+p.prop43.value+' i alt</span> | ';
					}
					else if(p.prop107 && p.prop107.value != '') {
						data += '<span>'+p.prop107.value+' i alt</span> | ';
					}
				}
			}
		}
		else {
			for(var i = 0; i < this.contentOrder.length; i++) {
				if(this.contentOrder[i] != 25 && this.contentOrder[i] != 33 && this.contentOrder[i] != 86) {
					var key = 'prop'+this.contentOrder[i];
					if(this[key] != undefined && p[key]) {
						var temp = this[key](p, true);
						if(temp != '') {
							data += temp+' | ';
						}
					}
					else if(p[key]) {
						var temp = this[p[key].type](p[key], true);
						if(temp != '') {
							data += temp+' | ';
						}
					}
				}
			}
			data = data.replace(/[, ]+$\s*$/, '');
		}

		return data;
	};
}

export default ContentController
